module.exports = __webpack_public_path__ + "img/Icon12_06.3db53054.svg";